// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assignment-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.assignment-modal {
  position: relative;
  width: 95%;
  max-width: 500px;
  max-height: 450px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.assignment-modal .assignment-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}
.assignment-modal .assignment-modal-header h3 {
  margin: 0;
  color: #374151;
  font-size: 18px;
  font-weight: 600;
}
.assignment-modal .assignment-modal-header .assignment-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 4px;
}
.assignment-modal .assignment-modal-header .assignment-modal-close:hover {
  background: #e5e7eb;
  color: #374151;
}
.assignment-modal .assignment-modal-content {
  flex: 1 1;
  padding: 24px;
  overflow-y: auto;
}
.assignment-modal .assignment-modal-content .assignment-modal-section {
  margin-bottom: 28px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section:last-child {
  margin-bottom: 0;
}
.assignment-modal .assignment-modal-content .assignment-modal-section h4 {
  margin: 0 0 12px 0;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .section-header .assignment-switch-mode-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .section-header .assignment-switch-mode-btn:hover {
  background: #2563eb;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container {
  max-height: 300px;
  min-height: 150px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container .user-checkbox-label {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 8px;
  cursor: pointer;
  border-radius: 4px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container .user-checkbox-label:hover {
  background-color: #f9fafb;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container .user-checkbox-label input[type=checkbox] {
  margin: 0;
  cursor: pointer;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container .user-checkbox-label .user-name {
  font-size: 14px;
  color: #374151;
  flex: 1 1;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 16px;
  min-height: 120px;
  max-height: 250px;
  overflow-y: auto;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .assigned-user-item, .assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .delete-user-item, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .assigned-user-item, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .delete-user-item {
  display: flex;
  align-items: center;
  padding: 10px 8px;
  border-bottom: 1px solid #f3f4f6;
  border-radius: 4px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .assigned-user-item:last-child, .assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .delete-user-item:last-child, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .assigned-user-item:last-child, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .delete-user-item:last-child {
  border-bottom: none;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .assigned-user-item .user-number, .assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .delete-user-item .user-number, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .assigned-user-item .user-number, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .delete-user-item .user-number {
  font-weight: 500;
  color: #6b7280;
  min-width: 24px;
  font-size: 14px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .assigned-user-item .user-name, .assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .delete-user-item .user-name, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .assigned-user-item .user-name, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .delete-user-item .user-name {
  flex: 1 1;
  color: #374151;
  font-size: 14px;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .assigned-user-item .assignment-delete-individual-btn, .assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .delete-user-item .assignment-delete-individual-btn, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .assigned-user-item .assignment-delete-individual-btn, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .delete-user-item .assignment-delete-individual-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background: #ef4444;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}
.assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .assigned-user-item .assignment-delete-individual-btn:hover, .assignment-modal .assignment-modal-content .assignment-modal-section .current-assignments .delete-user-item .assignment-delete-individual-btn:hover, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .assigned-user-item .assignment-delete-individual-btn:hover, .assignment-modal .assignment-modal-content .assignment-modal-section .delete-assignments-container .delete-user-item .assignment-delete-individual-btn:hover {
  background: #dc2626;
}
.assignment-modal .assignment-modal-footer {
  display: flex;
  gap: 12px;
  padding: 20px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  justify-content: flex-end;
}
.assignment-modal .assignment-modal-footer button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}
.assignment-modal .assignment-modal-footer button.assignment-save-btn {
  background: #10b981;
  color: white;
}
.assignment-modal .assignment-modal-footer button.assignment-save-btn:hover {
  background: #059669;
  transform: translateY(-1px);
}
.assignment-modal .assignment-modal-footer button.assignment-delete-all-btn {
  background: #ef4444;
  color: white;
}
.assignment-modal .assignment-modal-footer button.assignment-delete-all-btn:hover {
  background: #dc2626;
  transform: translateY(-1px);
}
.assignment-modal .assignment-modal-footer button.assignment-cancel-btn {
  background: #6b7280;
  color: white;
}
.assignment-modal .assignment-modal-footer button.assignment-cancel-btn:hover {
  background: #4b5563;
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .assignment-modal-overlay {
    padding: 10px;
  }
  .assignment-modal {
    width: 98%;
    min-width: 320px;
    max-height: 90vh;
  }
  .assignment-modal .assignment-modal-header {
    padding: 16px;
  }
  .assignment-modal .assignment-modal-header h3 {
    font-size: 16px;
  }
  .assignment-modal .assignment-modal-content {
    padding: 16px;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section {
    margin-bottom: 20px;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section .section-header {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section .section-header .assignment-switch-mode-btn {
    align-self: flex-start;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container {
    max-height: 150px;
  }
  .assignment-modal .assignment-modal-footer {
    padding: 16px;
    flex-direction: column;
  }
  .assignment-modal .assignment-modal-footer button {
    width: 100%;
    justify-content: center;
  }
}
@media (max-width: 480px) {
  .assignment-modal {
    width: 98%;
    min-width: 300px;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section .user-selection-container {
    max-height: 200px;
    min-height: 120px;
    padding: 12px;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section .user-checkbox-label {
    padding: 8px 6px;
  }
  .assignment-modal .assignment-modal-content .assignment-modal-section .user-checkbox-label .user-name {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/AssignmentModal/AssignmentModal.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,gBAAA;EAEA,iBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AADF;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gCAAA;AADJ;AAGI;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AADN;AAII;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AAFN;AAIM;EACE,mBAAA;EACA,cAAA;AAFR;AAOE;EACE,SAAA;EACA,aAAA;EACA,gBAAA;AALJ;AAOI;EACE,mBAAA;AALN;AAOM;EACE,gBAAA;AALR;AAQM;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AANR;AASM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAPR;AASQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,iCAAA;AAPV;AASU;EACE,mBAAA;AAPZ;AAYM;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;AAVR;AAYQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AAVV;AAYU;EACE,yBAAA;AAVZ;AAaU;EACE,SAAA;EACA,eAAA;AAXZ;AAcU;EACE,eAAA;EACA,cAAA;EACA,SAAA;AAZZ;AAiBM;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;AAfR;AAiBQ;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;AAfV;AAiBU;EACE,mBAAA;AAfZ;AAkBU;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAhBZ;AAmBU;EACE,SAAA;EACA,cAAA;EACA,eAAA;AAjBZ;AAoBU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AAlBZ;AAoBY;EACE,mBAAA;AAlBd;AA0BE;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,yBAAA;AAxBJ;AA0BI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;AAxBN;AA0BM;EACE,mBAAA;EACA,YAAA;AAxBR;AA0BQ;EACE,mBAAA;EACA,2BAAA;AAxBV;AA4BM;EACE,mBAAA;EACA,YAAA;AA1BR;AA4BQ;EACE,mBAAA;EACA,2BAAA;AA1BV;AA8BM;EACE,mBAAA;EACA,YAAA;AA5BR;AA8BQ;EACE,mBAAA;EACA,2BAAA;AA5BV;;AAoCA;EACE;IACE,aAAA;EAjCF;EAoCA;IACE,UAAA;IACA,gBAAA;IACA,gBAAA;EAlCF;EAoCE;IACE,aAAA;EAlCJ;EAoCI;IACE,eAAA;EAlCN;EAsCE;IACE,aAAA;EApCJ;EAsCI;IACE,mBAAA;EApCN;EAsCM;IACE,sBAAA;IACA,oBAAA;IACA,QAAA;EApCR;EAsCQ;IACE,sBAAA;EApCV;EAwCM;IACE,iBAAA;EAtCR;EA2CE;IACE,aAAA;IACA,sBAAA;EAzCJ;EA2CI;IACE,WAAA;IACA,uBAAA;EAzCN;AACF;AA8CA;EACE;IACE,UAAA;IACA,gBAAA;EA5CF;EAgDM;IACE,iBAAA;IACA,iBAAA;IACA,aAAA;EA9CR;EAiDM;IACE,gBAAA;EA/CR;EAiDQ;IACE,eAAA;EA/CV;AACF","sourcesContent":[".assignment-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 20px;\r\n}\r\n\r\n.assignment-modal {\r\n  position: relative;\r\n  width: 95%;\r\n  max-width: 500px;\r\n  //min-width: 500px;\r\n  max-height: 450px;\r\n  //min-height: 400px;\r\n  background: white;\r\n  border-radius: 8px;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n\r\n  .assignment-modal-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 20px;\r\n    background: #f8f9fa;\r\n    border-bottom: 1px solid #e9ecef;\r\n\r\n    h3 {\r\n      margin: 0;\r\n      color: #374151;\r\n      font-size: 18px;\r\n      font-weight: 600;\r\n    }\r\n\r\n    .assignment-modal-close {\r\n      background: none;\r\n      border: none;\r\n      cursor: pointer;\r\n      color: #6b7280;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      padding: 4px;\r\n      border-radius: 4px;\r\n\r\n      &:hover {\r\n        background: #e5e7eb;\r\n        color: #374151;\r\n      }\r\n    }\r\n  }\r\n\r\n  .assignment-modal-content {\r\n    flex: 1;\r\n    padding: 24px;\r\n    overflow-y: auto;\r\n\r\n    .assignment-modal-section {\r\n      margin-bottom: 28px;\r\n\r\n      &:last-child {\r\n        margin-bottom: 0;\r\n      }\r\n\r\n      h4 {\r\n        margin: 0 0 12px 0;\r\n        color: #374151;\r\n        font-size: 14px;\r\n        font-weight: 600;\r\n      }\r\n\r\n      .section-header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n        align-items: center;\r\n        margin-bottom: 12px;\r\n\r\n        .assignment-switch-mode-btn {\r\n          display: flex;\r\n          align-items: center;\r\n          gap: 4px;\r\n          padding: 6px 12px;\r\n          background: #3b82f6;\r\n          color: white;\r\n          border: none;\r\n          border-radius: 4px;\r\n          font-size: 12px;\r\n          cursor: pointer;\r\n          transition: background-color 0.2s;\r\n\r\n          &:hover {\r\n            background: #2563eb;\r\n          }\r\n        }\r\n      }\r\n\r\n      .user-selection-container {\r\n        max-height: 300px;\r\n        min-height: 150px;\r\n        overflow-y: auto;\r\n        border: 1px solid #e5e7eb;\r\n        border-radius: 6px;\r\n        padding: 16px;\r\n\r\n        .user-checkbox-label {\r\n          display: flex;\r\n          align-items: center;\r\n          gap: 10px;\r\n          padding: 10px 8px;\r\n          cursor: pointer;\r\n          border-radius: 4px;\r\n\r\n          &:hover {\r\n            background-color: #f9fafb;\r\n          }\r\n\r\n          input[type=\"checkbox\"] {\r\n            margin: 0;\r\n            cursor: pointer;\r\n          }\r\n\r\n          .user-name {\r\n            font-size: 14px;\r\n            color: #374151;\r\n            flex: 1;\r\n          }\r\n        }\r\n      }\r\n\r\n      .current-assignments, .delete-assignments-container {\r\n        border: 1px solid #e5e7eb;\r\n        border-radius: 6px;\r\n        padding: 16px;\r\n        min-height: 120px;\r\n        max-height: 250px;\r\n        overflow-y: auto;\r\n\r\n        .assigned-user-item, .delete-user-item {\r\n          display: flex;\r\n          align-items: center;\r\n          padding: 10px 8px;\r\n          border-bottom: 1px solid #f3f4f6;\r\n          border-radius: 4px;\r\n\r\n          &:last-child {\r\n            border-bottom: none;\r\n          }\r\n\r\n          .user-number {\r\n            font-weight: 500;\r\n            color: #6b7280;\r\n            min-width: 24px;\r\n            font-size: 14px;\r\n          }\r\n\r\n          .user-name {\r\n            flex: 1;\r\n            color: #374151;\r\n            font-size: 14px;\r\n          }\r\n\r\n          .assignment-delete-individual-btn {\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            width: 24px;\r\n            height: 24px;\r\n            background: #ef4444;\r\n            color: white;\r\n            border: none;\r\n            border-radius: 4px;\r\n            cursor: pointer;\r\n            transition: background-color 0.2s;\r\n\r\n            &:hover {\r\n              background: #dc2626;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .assignment-modal-footer {\r\n    display: flex;\r\n    gap: 12px;\r\n    padding: 20px;\r\n    background: #f8f9fa;\r\n    border-top: 1px solid #e9ecef;\r\n    justify-content: flex-end;\r\n\r\n    button {\r\n      display: flex;\r\n      align-items: center;\r\n      gap: 6px;\r\n      padding: 8px 16px;\r\n      border: none;\r\n      border-radius: 6px;\r\n      cursor: pointer;\r\n      font-size: 14px;\r\n      font-weight: 500;\r\n      transition: all 0.2s;\r\n\r\n      &.assignment-save-btn {\r\n        background: #10b981;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background: #059669;\r\n          transform: translateY(-1px);\r\n        }\r\n      }\r\n\r\n      &.assignment-delete-all-btn {\r\n        background: #ef4444;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background: #dc2626;\r\n          transform: translateY(-1px);\r\n        }\r\n      }\r\n\r\n      &.assignment-cancel-btn {\r\n        background: #6b7280;\r\n        color: white;\r\n\r\n        &:hover {\r\n          background: #4b5563;\r\n          transform: translateY(-1px);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Responsive design\r\n@media (max-width: 768px) {\r\n  .assignment-modal-overlay {\r\n    padding: 10px;\r\n  }\r\n\r\n  .assignment-modal {\r\n    width: 98%;\r\n    min-width: 320px;\r\n    max-height: 90vh;\r\n\r\n    .assignment-modal-header {\r\n      padding: 16px;\r\n\r\n      h3 {\r\n        font-size: 16px;\r\n      }\r\n    }\r\n\r\n    .assignment-modal-content {\r\n      padding: 16px;\r\n\r\n      .assignment-modal-section {\r\n        margin-bottom: 20px;\r\n\r\n        .section-header {\r\n          flex-direction: column;\r\n          align-items: stretch;\r\n          gap: 8px;\r\n\r\n          .assignment-switch-mode-btn {\r\n            align-self: flex-start;\r\n          }\r\n        }\r\n\r\n        .user-selection-container {\r\n          max-height: 150px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .assignment-modal-footer {\r\n      padding: 16px;\r\n      flex-direction: column;\r\n\r\n      button {\r\n        width: 100%;\r\n        justify-content: center;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .assignment-modal {\r\n    width: 98%;\r\n    min-width: 300px;\r\n\r\n    .assignment-modal-content {\r\n      .assignment-modal-section {\r\n        .user-selection-container {\r\n          max-height: 200px;\r\n          min-height: 120px;\r\n          padding: 12px;\r\n        }\r\n\r\n        .user-checkbox-label {\r\n          padding: 8px 6px;\r\n\r\n          .user-name {\r\n            font-size: 14px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
